module.exports = __webpack_public_path__ + "static/assets/1e852f8aa425e90a92236f2268591f80.png";